export const urlConfig = "https://x-management.herokuapp.com/graphql";

export const urlPost = "https://x-management.herokuapp.com/api/auth/login"